module.exports = __webpack_public_path__ + "static/media/download-icon-red.c1d42e30.svg";